import { createAsyncThunk } from '@reduxjs/toolkit';

import { findMeList } from '~/services/producer/Me';

export const fetchMeList = createAsyncThunk(`me/fetchMeList`, async () => {
  const data = await findMeList();
  return data;
});
